import styled from 'styled-components'




export const VideoBg = styled.video`
    width: 100%;
    height: 100%;
    -o-object-fit: cover;
    object-fit: cover;
    background: #232a34;
`

export const Bg = styled.div`
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
`
export const Container = styled.div`
    z-index: 9;
    display: flex;
    flex-direction: row;
    justify-content: center;
    position: ;
    color: #fff;
    
`
export const Card = styled.div`
    z-index: 10;
    background-color: rgba(0,0,0,0.89);;
    width: 700px;
    height: 600px;
    margin: 200px 50px 50px 50px; 
    text-align: center;
`

export const Heading = styled.h1`
    z-index: 2;
    
    font-size: 20px;
    padding: 30px 0px 50px 50px;
    justify-content: center;
    text-align: left;
`

export const Box = styled.form`
    width: 100%;
`

export const Input = styled.textarea`
    width: 80%;
    height: 350px;
    justify-content: top;  
    font-size: 20px;
    color: black;
`

export const Button2 = styled.button`
    padding: 2px;
    margin: 40px;
    font-size:
    z-index: 2;
    text-decoration: none;
    font-size: 20px;
    justify-content: center;
    text-align: left;

`

export const Submit = styled.input`

    padding: 2px;
    margin: 40px;
    font-size:
    z-index: 2;
    text-decoration: none;
    font-size: 20px;
    justify-content: center;
    text-align: left;
`

export const Text = styled.div`
    z-index: 2;
    font-size: 20px;
    padding: 39px 0px 25px 30px;
    justify-content: center;
    text-align: left;
`

